import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { uniq, compact } from 'lodash';

import ResolvePaymentIssuesComponent, { NOTIFY_MEMBERS_OPTION } from '../components/resolve-payment-issues/index';
import {
  getCurrentUserMembership,
  getFailedInviteeMemberships,
  getShortMemberships,
  getCurrentPurchase,
} from '../selectors/purchase-selector';
import {
  hideResolveIssuesModal,
  showRemoveModal,
  notifyFailedMemberships,
  showAlert,

  ALERT_DASHBOARD_REMINDERS_SENT,
} from '../actions/index';
import money, { Money } from '../lib/money';

class ResolvePaymentIssues extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(props) {
    const { currentPayment, authentication } = this.props;
    const optionSelected = props.resolveOption;
    this.props.actions.hideResolveIssuesModal();

    if (optionSelected === NOTIFY_MEMBERS_OPTION) {
      this.props.actions.notifyFailedMemberships(currentPayment.id, authentication)
        .then(() => {
          this.props.actions.showAlert(ALERT_DASHBOARD_REMINDERS_SENT);
        });
    } else {
      this.props.actions.showRemoveModal({
        memberships: this.membershipsWithIssues(),
        resolveOptions: {
          summary: this.failedMembershipsSummary(),
          optionSelected,
        },
      });
    }
  }

  membershipsWithIssues() {
    const { failedMemberships, shortMemberships } = this.props;
    return uniq([...failedMemberships, ...shortMemberships]);
  }

  failedMembershipsSummary() {
    const memberships = this.membershipsWithIssues();
    const sumClaimedSlots = memberships.reduce((total, membership) => (total + membership.claimedSlots), 0);
    const sumShareAmount = Money.sum(compact(memberships.map(member => money(member.shareAmount))));

    return {
      claimedSlots: sumClaimedSlots,
      shareAmount: sumShareAmount,
    };
  }

  render() {
    return (
      <ResolvePaymentIssuesComponent
        onSubmit={this.onSubmit}
        onCancel={this.props.actions.hideRemoveModal}

        failedMemberships={this.props.failedMemberships}
        shortMemberships={this.props.shortMemberships}
        initialValues={this.props.initialValues}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);

  return {
    authentication: state.session.authentication,
    currentPayment: purchase && purchase.currentPayment,
    userMembership: getCurrentUserMembership(state),
    failedMemberships: getFailedInviteeMemberships(state),
    shortMemberships: getShortMemberships(state),
    initialValues: {
      resolveOption: 'notify',
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    hideResolveIssuesModal,
    showRemoveModal,
    notifyFailedMemberships,
    showAlert,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResolvePaymentIssues);




// WEBPACK FOOTER //
// ./src/desktop/containers/resolve-payment-issues.container.js